import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=a629640a&"
import script from "./ServiceList.vue?vue&type=script&lang=js&"
export * from "./ServiceList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceList.vue?vue&type=style&index=0&id=a629640a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports